import { useState, useEffect } from "react";
import LanguageSection from "../components/language/LanguageSection";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [language, setLanguage] = useState("en"); // Default language is English
  const { t } = useTranslation("footer"); // Hook to use translations

  return (
    <footer className="bg-black">
      <div className="relative mx-auto px-[30px] max-w-[1220px] mt-[55px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-y-10 md:gap-x-12 py-6 lg:py-2">
          <div>
            <h2 className="mb-6 title-small-3 text-color"><a href="about_us">{t("about_us")}</a></h2>
            <ul className="body-regular-2 text-color-2 mt-[40px]">
              <li className="mb-4"><a href="/services">{t("services")}</a></li>
              <li className="mb-4"><a href="/products_from_vendors">{t("products_from_vendors")}</a></li>
              <li className="mb-4"><a href="/our_cases">{t("our_cases")}</a></li>
              <li className="mb-4"><a href="/r&d">{t("r_and_d")}</a></li>
              {/* <li className="mb-4"><a href="/distributor_certificates">{t("distributor_certificates")}</a></li> */}
              <li className="mb-4"><a href="/our_team">{t("our_team")}</a></li>
            </ul>
          </div>

          <div>
            <h2 className="mb-6 title-small-3 text-color"><a href="contact_us">{t("contact_us")}</a></h2>
            <ul className="body-regular-2 text-color-2 mt-[40px]">
              <li className="mb-4">{t("newstrax_headquarters")}</li>
              <li className="mb-4">{t("address")}</li>
              <li className="mb-4">{t("city_state_zip")}</li>
              <li className="mb-4"><a href="tel:+15551234567">{t("phone")}</a></li>
            </ul>
          </div>

          <div className="flex flex-col col-span-1 md:col-span-2 items-start md:items-center space-y-6 mt-8 md:mt-0">
            {/* Social Media Icons */}
            <div className="flex justify-center md:justify-start space-x-10">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/linkedin.svg" alt="LinkedIn" className="h-10 w-10" />
              </a>
              <a href="https://twitter.com/login" target="_blank" rel="noopener noreferrer">
                <img src="/assets/twitter.svg" alt="Twitter" className="h-10 w-10" />
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/youtube.svg" alt="YouTube" className="h-10 w-10" />
              </a>
            </div>

            {/* Language Selector */}
            <div className="md:ml-12 w-[256px] md:w-auto">
              <LanguageSection setLanguage={setLanguage} />
            </div>
          </div>
        </div>

        <div className="border-t border-[#FFFFFF1A]"></div>

        <div className="py-6 bg-black md:flex md:items-center md:justify-between mb-12 mt-4 gap-6">
          <a href="/" className="text-sm text-gray-300 sm:text-center flex items-center">
            <img src="/assets/logo.png" alt="Logo" />
          </a>

          <div className="text-color flex mt-4 sm:justify-start md:mt-0 space-x-5">
            <span>
              {t("copyright_notice")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
